module.exports = require('./dist/lib/link')



//////////////////
// WEBPACK FOOTER
// ./node_modules/next/link.js
// module id = ./node_modules/next/link.js
// module chunks = 6 9 11